<div style="margin-bottom: 2rem;">
  <div class="display-flex" style="margin-bottom: 1rem; align-items: center">
    <mat-icon class="icon">insights</mat-icon>
    <div class="display-flex flex-column">
      <span class="title">{{ 'settings.metrics' | translate }}</span>
      <span class="description">{{ 'notification.select-metric' | translate }}</span>
    </div>
  </div>
  <app-metric-selector [form]="form"
                       controlName="metric"
                       [suppressLabel]="true"></app-metric-selector>
</div>
